import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import WhoWeAre from "../components/WhoWeAre";
import Consultant from "../components/Consultant";
import Confidants from "../components/Confidants";
import Fields from "../components/Fields";
import Portfolio from "../components/Portfolio";
import CTASection from "../components/CTASection";
import Footer from "../components/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page">
      <Navbar />
      <Hero />
      <WhoWeAre />
      <Consultant />
      <Confidants />
      <Fields />
      <Portfolio />
      <CTASection />
      <Footer />
    </div>
  );
}
